/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedBlurbPcs_vipUserRelationship = {|
  +userDataB: ?$ReadOnlyArray<?{|
    +email?: ?string;
    +firstName?: ?string;
    +phoneNumber?: ?string;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedBlurbPcs_vipUserRelationship",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": null,
      "name": "userDataB",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "VipRepData",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "email",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "firstName",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "formatType",
                  "value": "INTERNATIONAL",
                  "type": "formatPhoneNumberTypes"
                }
              ],
              "name": "phoneNumber",
              "storageKey": "phoneNumber{\"formatType\":\"INTERNATIONAL\"}"
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserRelationship"
};

module.exports = fragment;
